import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import forms from './forms'

const namespaced = true

const state =  {
  data: {
    accessToken: null,
    refreshToken: null
  }
}

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations,
  modules: {
    forms
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/token/index.js